import { Injectable } from '@angular/core'
import { CountryDTO } from '../../components/types'
import { MbConstants } from '../../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class CmsCountryService {

  getCountryByISO (iso: string) {
    return CmsCountryService.countries.find(country => country.ISO === iso) ?? CmsCountryService.countries.find(country => country.ISO === MbConstants.FALLBACK_COUNTRY)
  }

  static readonly countries: CountryDTO[] = [
    { ISO: 'BE', name: 'Belgium', adjective: 'Belgian', nationalName: 'Belgique' },
    { ISO: 'LU', name: 'Luxembourg', adjective: 'Luxembourg', nationalName: 'Lëtzebuerg' },
    { ISO: 'NL', name: 'Netherlands', adjective: 'Dutch', nationalName: 'Nederland' },
    { ISO: 'DE', name: 'Germany', adjective: 'German', nationalName: 'Deutschland' },
    { ISO: 'CH', name: 'Switzerland', adjective: 'Swiss', nationalName: 'Schweiz' },
    { ISO: 'AT', name: 'Austria', adjective: 'Austrian', nationalName: 'Österreich' },
    { ISO: 'ES', name: 'Spain', adjective: 'Spanish', nationalName: 'España' },
    { ISO: 'FR', name: 'France', adjective: 'French', nationalName: 'France' },
    { ISO: 'IT', name: 'Italia', adjective: 'Italian', nationalName: 'Italia' },
    { ISO: 'FI', name: 'Finland', adjective: 'Finnish', nationalName: 'Suomi' },
    { ISO: 'NO', name: 'Norway', adjective: 'Norwegian', nationalName: 'Norge' },
    { ISO: 'SE', name: 'Sweden', adjective: 'Swedish', nationalName: 'Sverige' },
    { ISO: 'GB', name: 'Great Britain', adjective: 'British', nationalName: 'Great Britain' },
    { ISO: 'IE', name: 'Ireland', adjective: 'Irish', nationalName: 'Ireland' },
    { ISO: 'CA', name: 'Canada', adjective: 'Canadian', nationalName: 'Canada' },
    { ISO: 'US', name: 'USA', adjective: 'US', nationalName: 'USA' },
    { ISO: 'AU', name: 'Australia', adjective: 'Australian', nationalName: 'Australia' },
    { ISO: 'SG', name: 'Singapore', adjective: 'Singaporean', nationalName: 'Singapore' },
    { ISO: 'KR', name: 'South Korea', adjective: 'South Korean', nationalName: '대한민국' },
    { ISO: 'CN', name: 'China', adjective: 'Chinese', nationalName: '中国' },
    { ISO: 'JP', name: 'Japan', adjective: 'Japanese', nationalName: '日本' },
    { ISO: 'HK', name: 'Hong Kong', adjective: 'Hong Kong', nationalName: '香港' },
    { ISO: 'UN', name: 'International', adjective: 'International', nationalName: 'International' },
    { ISO: 'DK', name: 'Denmark', adjective: 'Danish', nationalName: 'Danmark' },
    { ISO: 'IS', name: 'Iceland', adjective: 'Icelandic', nationalName: 'Ísland' },
    { ISO: 'LI', name: 'Liechtenstein', adjective: 'Liechtenstein', nationalName: 'Liechtenstein' },
    { ISO: 'SM', name: 'San Marino', adjective: 'Sammarinese', nationalName: 'San Marino' },
    { ISO: 'LV', name: 'Latvia', adjective: 'Latvian', nationalName: 'Latvija' },
    { ISO: 'AD', name: 'Andorra', adjective: 'Andorran', nationalName: 'Principat d’Andorra' },
    { ISO: 'IN', name: 'India', adjective: 'Indian', nationalName: 'भारत' },
  ]
}
